// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { recentlyPurchasedLinkStyles } from "@keller/App/Components/Header/RecentlyPurchasedLink";
import breakpoints from "@keller/XDL/PreStyle/breakpoints";
import { css } from "styled-components";

recentlyPurchasedLinkStyles.floatingTooltip = {
    tooltipContent: {
        css: css`
            padding: 20px;
            border-radius: 0;
            max-width: ${breakpoints.maxWidths[4] - 2 * (breakpoints as any).paddingValues[4]}px;
            max-height: 80vh;
        `,
    },
};
